// import 'dotenv/config'
// import 'preact/debug';
import habitat from 'preact-habitat';
import Widget from './Widget';

const { render } = habitat(Widget);

// @ts-ignore
window.renderAssist = (force = false) => {
  if (
    !force &&
    // @ts-ignore
    (document.querySelector('[data-widget-host="taker-assist"]')?._habitat ||
      document.querySelector('.taker-assist.mask') ||
      document.querySelector('.taker-assist.content_ta')) &&
    // @ts-ignore
    typeof window.updateAssist === 'function'
  ) {
    // @ts-ignore
    window.updateAssist();
  } else {
    // @ts-ignore
    if (typeof window.unmountAssist === 'function') {
      // @ts-ignore
      window.unmountAssist();
    }

    render({
      selector: '[data-widget-host="taker-assist"]',
      clean: true,
      clientSpecified: true,
    });
  }
};
